import { AdvancedGridTable, useAuxWindow } from "@apex/component-library";
import { CellClickedEvent } from "ag-grid-community";
import { useNavigate, useSearchParams } from "react-router-dom";

import { usePermissions } from "../../contexts/permissions";
import { AppRoutes } from "../../routes";
import { CallDetailResultFromAPI, Record } from "../../types";
import { APP_ID } from "../../utils/constants";
import CallAlertsAuxWindow from "../CallAlertsAuxWindow";
import { getBaseDetailPopOutUrl } from "../CallAlertsAuxWindow/utils";
import getColumns from "./getColumns";
import getRecords from "./getRecords";

type Props = {
  searchResults: CallDetailResultFromAPI[];
};

const CallsAlertsResultsGrid = ({ searchResults }: Props) => {
  const { permissions } = usePermissions();
  const [searchParams] = useSearchParams();
  const newAuxWindow = useAuxWindow(state => state.newAuxWindow);
  const navigate = useNavigate();

  const columns = getColumns(permissions);
  const records = getRecords(searchResults);

  function handleCellClick(event: CellClickedEvent<Record>) {
    const { data } = event;
    if (event.colDef.colId !== "actionMenu" && data) {
      newAuxWindow({
        heading: "Call / Alert Detail",
        body: <CallAlertsAuxWindow record={data} />,
        id: data.callId,
        sizing: { height: 560, minHeight: 200, minWidth: 360, width: 600 },
        popOutUrl: getBaseDetailPopOutUrl(data.callId),
      });
    }
  }

  return (
    <AdvancedGridTable
      headerTitle="Results"
      columnDefs={columns}
      rowData={records}
      gridId={`${APP_ID}.calls-alerts-search-results`}
      onCellClicked={handleCellClick}
      data-testid="margin-call-results"
      rowStyle={{ cursor: "pointer" }}
      rowClass="calls-alerts-row"
      onExportClick={() => navigate(`/${AppRoutes.Export}?${searchParams}`)}
    />
  );
};

export default CallsAlertsResultsGrid;
